import { useEffect } from "react";
import { playTick } from "@/lib/sound";

const SELECTOR = 'a, button, [role="tab"], [role="option"], [role="menuitem"]';

export function useHoverTicks() {
  useEffect(() => {
    let last = null;
    const onOver = (e) => {
      const el = e.target.closest?.(SELECTOR);
      if (!el || el.disabled) return;
      if (el !== last) {
        last = el;
        playTick();
      }
    };
    const onOut = (e) => {
      if (last && !last.contains(e.relatedTarget)) last = null;
    };
    document.addEventListener("pointerover", onOver);
    document.addEventListener("pointerout", onOut);
    return () => {
      document.removeEventListener("pointerover", onOver);
      document.removeEventListener("pointerout", onOut);
    };
  }, []);
}
